import { useEffect } from 'react'
import { revalidateMe } from '../lib/me.js'

/**
 * Global session-expiry watch. Mounted once at the app root.
 *
 * The session cookie carries an `exp`; once it passes, /__app/me returns 401.
 * A long-open SPA tab won't notice on its own (client-side routing never hits
 * the server middleware), so we proactively re-check /__app/me:
 *   - every 2 minutes
 *   - when the tab becomes visible again
 *   - when the window regains focus
 * revalidateMe() force-logs-out on a 401 (→ /__app/logout → login). Renders nothing.
 */
const INTERVAL_MS = 120000

export default function AuthWatcher() {
  useEffect(() => {
    const check = () => { revalidateMe() }
    const onVisible = () => { if (document.visibilityState === 'visible') check() }

    check() // validate immediately on mount (catches an already-expired Xano token)
    const timer = setInterval(check, INTERVAL_MS)
    window.addEventListener('focus', check)
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      clearInterval(timer)
      window.removeEventListener('focus', check)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [])

  return null
}
